import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { addCompany } from '../../apis/CompanyAPI';

export default function AddCompany({ onCompanyAdded }) {
    const [open, setOpen] = React.useState(false);
    const [name, setName] = React.useState('');
    const [description, setDescription] = React.useState('');
    const [credits, setCredits] = React.useState('');
    const [recurringCredits, setRecurringCredits] = React.useState('');

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmit = async () => {
        try {
            await addCompany({
                name: name,
                description: description,
                meeting_creds: credits,
                recurring_credits: recurringCredits
            });
            handleClose();
            onCompanyAdded();
        } catch (error) {
            console.error('Error adding Company:', error);
        }
    };

    return (
        <React.Fragment>
            <AddRoundedIcon onClick={handleClickOpen} sx={{
                color: "black",
                background: "none",
                border: "none",
                float: "right",
                margin: "0px 0px 0px 10px",
            }} />
            <Dialog
                open={open}
                onClose={handleClose}
                PaperProps={{
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        handleSubmit();
                    },
                }}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>New Company</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        To add a company, please fill in these fields.
                    </DialogContentText>
                    <TextField
                        required
                        sx={{ mt: 3 }}
                        name='name'
                        value={name}
                        margin='dense'
                        id='description'
                        label='Company Name'
                        type='text'
                        fullWidth
                        variant='outlined'
                        onChange={(e) => setName(e.target.value)}
                    />
                    <TextField
                        required
                        sx={{ mt: 3 }}
                        name='description'
                        value={description}
                        margin='dense'
                        id='description'
                        label='Description'
                        type='text'
                        fullWidth
                        variant='outlined'
                        onChange={(e) => setDescription(e.target.value)}
                    />
                    <TextField
                        required
                        sx={{ mt: 3 }}
                        name='credits'
                        value={credits}
                        margin="dense"
                        id="credits"
                        label="Credits"
                        type="number"
                        fullWidth
                        variant="outlined"
                        onChange={(e) => setCredits(e.target.value)}
                    />
                    <TextField
                        required
                        sx={{ mt: 3 }}
                        name='recurringCredits'
                        value={recurringCredits}
                        margin="dense"
                        id="recurringCredits"
                        label="Recurring Credits"
                        type="number"
                        fullWidth
                        variant="outlined"
                        onChange={(e) => setRecurringCredits(e.target.value)}
                    />
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center", paddingBottom: "20px" }}>
                    <Button onClick={handleClose} variant='outlined'>Cancel</Button>
                    <Button type="submit" variant='contained'>Add</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
